export default class QRCode {
	constructor() {
		this.d = document.getElementById('qrcode')
		this.b = this.d.parentNode
		this.btns = document.querySelectorAll('.show-qrcode')

		this.btns.forEach(btn => btn.onclick = this.open.bind(this))
		this.d.addEventListener('click', (e) => e.stopPropagation())
		this.b.addEventListener('click', this.close.bind(this))
	}

	open(e) {
		e.preventDefault()
		document.documentElement.classList.add('has-dialog')
		this.b.classList.add('active')
		this.d.classList.remove('hidden')
	}

	close() {
		document.documentElement.classList.remove('has-dialog')
		this.b.classList.remove('active')
		this.d.classList.add('hidden')
	}
}
